module.exports = __webpack_public_path__ + "img/Home.2cea1ce6.svg";